import React, { Component, PropTypes } from 'react'
import { Field } from 'redux-form'
import cx from 'classnames'

import './PromoCodeForm.scss'
import InputControl from 'components/InputControl'
import * as localStorage from 'utils/localStorage'

class PromoCodeForm extends Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount () {
    this.applyPromoCode()
  }

  applyPromoCode () {
    const promoCode = localStorage.getItem('aliada_promoCode')
    if (promoCode) {
      this.handleSubmit({ code: promoCode })
    }
  }

  handleSubmit (formData) {
    const { code } = formData
    this.props.redeemPromoCode(code)
  }

  render () {
    const {
      promoCode,
      redeemingPromoCode,
      handleSubmit
    } = this.props

    const submitButtonClassName = cx(
      'FirstTimePromoCodeForm-submitButton',
      'btn btn-lg btn-block',
      promoCode.valid ? 'btn-success' : 'btn-default'
    )

    return (
      <form
        onSubmit={handleSubmit(this.handleSubmit)}
        className='FirstTimePromoCodeForm'
        >
        <p>¿Tienes una promoción? Aplícala ahora.</p>
        <Field
          type='text'
          name='code'
          component={InputControl}
          icon='coupon'
          label='Código de promoción' />
        <button
          type='submit'
          disabled={redeemingPromoCode}
          className={submitButtonClassName}>
          {
            promoCode.valid
              ? 'Promoción aplicada con éxito'
              : 'Aplicar promoción'
          }
        </button>
      </form>
    )
  }
}
PromoCodeForm.displayName = 'PromoCodeForm'
PromoCodeForm.propTypes = {
  promoCode: PropTypes.object,
  redeemingPromoCode: PropTypes.bool,
  redeemPromoCode: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
}
PromoCodeForm.defaultProps = {
  promoCode: {},
  redeemingPromoCode: false
}

export default PromoCodeForm



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/FirstTimeBookingConfirmation/components/PromoCodeForm/PromoCodeForm.js